import { render, staticRenderFns } from "./FromSat.vue?vue&type=template&id=3b1495c6"
import script from "./FromSat.vue?vue&type=script&lang=js"
export * from "./FromSat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b1495c6')) {
      api.createRecord('3b1495c6', component.options)
    } else {
      api.reload('3b1495c6', component.options)
    }
    module.hot.accept("./FromSat.vue?vue&type=template&id=3b1495c6", function () {
      api.rerender('3b1495c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/invoices/FromSat.vue"
export default component.exports